export class CPF {
  static unmask(cpf) {
    return String(cpf).replace(/[^0-9]+/g, "");
  }

  static mask(cpf) {
    const normalizedCpf = CPF.unmask(cpf);

    return normalizedCpf.replace(
      /^([0-9]{3})([0-9]{3})([0-9]{3})([0-9]{2})$/,
      "$1.$2.$3-$4"
    );
  }

  static validate(cpf) {
    const normalizedCpf = CPF.unmask(cpf);

    if (!normalizedCpf || normalizedCpf.length < 11) {
      return false;
    }

    let cpfArray = `${normalizedCpf}`.split("");

    if (cpfArray.every((char) => char === cpfArray[0])) {
      return false;
    }

    let primeiroDigito =
      (cpfArray.slice(0, 9).reduce((carry, digito, idx) => {
        return carry + digito * (10 - idx);
      }, 0) *
        10) %
      11;
    let segundoDigito =
      (cpfArray.slice(0, 10).reduce((carry, digito, idx) => {
        return carry + digito * (11 - idx);
      }, 0) *
        10) %
      11;

    if (primeiroDigito > 9 && primeiroDigito < 12) {
      primeiroDigito = 0;
    }

    if (segundoDigito > 9 && segundoDigito < 12) {
      segundoDigito = 0;
    }

    let digitoVerificador = cpfArray.slice(9);

    if (
      digitoVerificador[0] != primeiroDigito ||
      digitoVerificador[1] != segundoDigito
    ) {
      return false;
    }

    return true;
  }
}
